import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

/**
 * Loading state while a chat is fetched when switching from history.
 * A conversation load is fast (a single server read), so this is a light
 * spinner + blur — NOT the rotating-narrative treatment used for the long
 * deep-research run (that text would never get a chance to cycle here).
 *
 * It only reveals after a short delay: a sub-150ms load shouldn't flash a
 * spinner at all, which would read as a flicker rather than feedback.
 */
const ConversationLoader = observer(() => {
  const loading = copilotStore.loadingConversation;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShow(false);
      return undefined;
    }
    const t = setTimeout(() => setShow(true), 150);
    return () => clearTimeout(t);
  }, [loading]);

  if (!show) return null;

  return (
    <div className="copilotConvoLoader">
      <div className="copilotConvoLoader__card">
        <span className="copilotConvoLoader__spinner" />
        <span className="copilotConvoLoader__text">Loading chat…</span>
      </div>
    </div>
  );
});

export default ConversationLoader;
